import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 0.4.0",
  "description": "Turborepo 0.4.0은 10배 빠른 해싱, 희소 설치를 통한 정리된 워크스페이스, 새로운 파이프라인 구성 API, 개선된 캐시 제어를 도입합니다.",
  "date": "2021/04/02",
  "tag": "web development",
  "ogImage": "/images/blog/joining-vercel/x-card.png"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo v0.4.0 릴리스를 발표하게 되어 기쁩니다!"
  }, {
    "heading": "",
    "content": "10배 빠름: turbo가 Go로 처음부터 다시 작성되어 훨씬 더 빠르게 되었습니다"
  }, {
    "heading": "",
    "content": "더 스마트한 해싱: 개선된 해싱 알고리즘이 이제 전체 루트 잠금 파일의 내용 대신 해결된 종속성을 고려합니다"
  }, {
    "heading": "",
    "content": "부분 잠금 파일 / 희소 설치: 주어진 대상에 필요한 패키지만 포함하는 정리된 루트 잠금 파일 및 모노레포 하위 집합을 생성합니다"
  }, {
    "heading": "",
    "content": "세밀한 스케줄링: pipeline 구성을 통한 개선된 작업 오케스트레이션 및 옵션"
  }, {
    "heading": "",
    "content": "더 나은 캐시 제어: 이제 작업별로 캐시 출력을 지정할 수 있습니다"
  }, {
    "heading": "go로-다시-작성됨",
    "content": "처음에는 TypeScript로 turbo의 프로토타입을 만들었지만, 로드맵의 특정 항목이 더 나은 성능을 요구한다는 것이 분명해졌습니다. 약 한 달간의 작업 끝에 드디어 Go 버전의 turbo CLI를 릴리스하게 되어 기쁩니다. 밀리초 단위로 부팅될 뿐만 아니라 새로운 Go 구현은 Node.js 구현보다 해싱에서 10배에서 100배 사이로 빠릅니다. 이 새로운 기반(그리고 곧 읽게 될 일부 기능)으로 Turborepo는 이제 Go의 놀라운 동시성 제어 덕분에 초은하계 크기의 프로젝트로 확장하면서도 놀랍도록 빠른 속도를 유지할 수 있습니다."
  }, {
    "heading": "더-나은-해싱",
    "content": "v0.4.0에서는 해싱이 더 빠를 뿐만 아니라 훨씬 더 스마트합니다."
  }, {
    "heading": "더-나은-해싱",
    "content": "주요 변경 사항은 turbo가 더 이상 해셔(주어진 작업이 캐시에 존재하는지 또는 실행해야 하는지 판단하는 알고리즘)에 루트 잠금 파일 내용의 해시를 포함하지 않는다는 것입니다. 대신 turbo는 이제 루트 잠금 파일을 기반으로 패키지의 dependencies 및 devDependencies의 해결된 버전 집합을 해시합니다."
  }, {
    "heading": "더-나은-해싱",
    "content": "이전 동작은 루트 잠금 파일이 어떤 방식으로든 변경될 때마다 캐시를 폭발시켰습니다. 이 새로운 동작으로 잠금 파일을 변경하면 추가/변경/제거된 종속성의 영향을 받는 패키지에 대해서만 캐시가 무효화됩니다. 복잡하게 들리지만, npm에서 종속성을 설치/제거/업데이트할 때 변경 사항의 영향을 실제로 받는 패키지만 다시 빌드하면 된다는 의미입니다."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "고객의 가장 큰 문제점/요청 중 하나는 대규모 Yarn Workspaces(또는 실제로 모든 워크스페이스 구현)로 작업할 때 Docker 빌드 시간을 개선하는 것이었습니다. 핵심 문제는 워크스페이스의 최고 기능--모노레포를 단일 잠금 파일로 줄이는 것--이 Docker 레이어 캐싱과 관련하여 최악이기도 하다는 것입니다."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "문제와 turbo가 이제 이를 해결하는 방법을 설명하기 위해 예를 살펴보겠습니다."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "frontend, admin, ui, backend라는 패키지 세트를 포함하는 Yarn 워크스페이스가 있는 모노레포가 있다고 가정해 봅시다. 또한 frontend와 admin이 동일한 내부 React 컴포넌트 라이브러리 패키지 ui에 모두 종속되는 Next.js 애플리케이션이라고 가정해 봅시다. 이제 backend에 모노레포의 다른 부분과 많은 코드를 공유하지 않는 Express TypeScript REST API가 포함되어 있다고 가정해 봅시다."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "frontend Next.js 앱의 Dockerfile은 다음과 같습니다:"
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "이것이 작동하는 동안 훨씬 더 나을 수 있는 몇 가지가 있습니다:"
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "대상 앱을 빌드하는 데 필요한 내부 패키지와 파일을 수동으로 COPY하고 어떤 것을 먼저 빌드해야 하는지 기억해야 합니다."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "Dockerfile에서 매우 일찍 루트 yarn.lock 잠금 파일을 올바른 위치로 COPY하지만, 이 잠금 파일은 전체 모노레포의 잠금 파일입니다."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "이 마지막 문제는 모노레포가 커질수록 특히 고통스러운데, 이 잠금 파일의 모든 변경이 앱이 실제로 새로운/변경된 종속성의 영향을 받는지 여부와 관계없이 거의 전체 재빌드를 트리거하기 때문입니다."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "....지금까지는."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "완전히 새로운 turbo prune 명령으로 이제 node_modules를 설치하지 않고도 대상 패키지에 대한 정리된 잠금 파일이 있는 희소/부분 모노레포를 결정적으로 생성하여 이 악몽을 해결할 수 있습니다."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "Docker 내부에서 turbo prune을 사용하는 방법을 살펴보겠습니다."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "그렇다면 turbo prune의 출력은 정확히 무엇일까요? 내부에 다음이 있는 out이라는 폴더입니다:"
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "정리된 워크스페이스의 package.json이 있는 json 폴더"
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "정리된 워크스페이스의 전체 소스 코드가 있지만 대상을 빌드하는 데 필요한 내부 패키지만 포함하는 full 폴더"
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "정리된 워크스페이스의 패키지에서 실제로 사용하는 종속성만 포함하는 원래 루트 잠금 파일의 정리된 하위 집합만 포함하는 새로운 정리된 잠금 파일."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "위의 덕분에 Docker는 이제 실제 이유가 있을 때만 각 애플리케이션을 다시 빌드하도록 설정할 수 있습니다. 따라서 frontend는 소스 또는 종속성(npm의 내부 또는 외부)이 실제로 변경된 경우에만 다시 빌드됩니다. admin과 backend도 마찬가지입니다. ui의 소스 코드 또는 종속성에 대한 변경은 frontend와 admin 모두의 재빌드를 트리거하지만 backend는 트리거하지 않습니다."
  }, {
    "heading": "실험적-정리된-워크스페이스",
    "content": "이 예제가 사소해 보이지만 각 앱을 빌드하고 배포하는 데 최대 20분이 걸린다고 상상해 보세요. 특히 대규모 팀에서 이러한 절약은 빠르게 누적되기 시작합니다."
  }, {
    "heading": "파이프라인",
    "content": "Turborepo를 더욱 세밀하게 제어할 수 있도록 turbo의 구성에 pipeline을 추가했습니다. turbo 구성의 이 새 필드를 사용하면 모노레포의 npm 스크립트가 서로 어떻게 관련되어 있는지 및 일부 추가 작업별 옵션을 지정할 수 있습니다. 그런 다음 turbo는 이 정보를 사용하여 모노레포의 작업을 최적으로 예약하고 그렇지 않으면 존재할 폭포를 축소합니다."
  }, {
    "heading": "파이프라인",
    "content": "작동 방식은 다음과 같습니다:"
  }, {
    "heading": "파이프라인",
    "content": "위의 구성은 turbo에 의해 해석되어 실행을 최적으로 예약합니다."
  }, {
    "heading": "파이프라인",
    "content": "실제로 무슨 의미일까요? 과거(Lerna 및 Nx와 같이)에는 turbo가 토폴로지 순서로만 작업을 실행할 수 있었습니다. 파이프라인을 추가하면 turbo는 이제 실제 종속성 그래프 외에도 토폴로지 \"작업\" 그래프를 구성하여 최대 동시성으로 작업을 실행해야 하는 순서를 결정하는 데 사용합니다. 최종 결과는 더 이상 작업이 완료되기를 기다리며 유휴 CPU 시간을 낭비하지 않는다는 것입니다(즉, 더 이상 폭포가 없습니다)."
  }, {
    "heading": "개선된-캐시-제어",
    "content": "pipeline 덕분에 이제 작업별로 turbo의 캐시 동작을 열 수 있는 좋은 장소가 생겼습니다."
  }, {
    "heading": "개선된-캐시-제어",
    "content": "위의 예를 기반으로 이제 다음과 같이 전체 모노레포에서 캐시 출력 규칙을 설정할 수 있습니다:"
  }, {
    "heading": "개선된-캐시-제어",
    "content": "참고: 현재 pipeline은 프로젝트 수준에 존재하지만,\n이후 릴리스에서는 패키지별로 재정의할 수 있습니다."
  }, {
    "heading": "다음은-무엇인가요",
    "content": "많은 내용이었지만 앞으로 더 많은 것이 있습니다. Turborepo 로드맵의 다음 내용은 다음과 같습니다."
  }, {
    "heading": "다음은-무엇인가요",
    "content": "랜딩 페이지!"
  }, {
    "heading": "다음은-무엇인가요",
    "content": "@turborepo/server를 사용한 원격 캐싱"
  }, {
    "heading": "다음은-무엇인가요",
    "content": "빌드 스캔, 원격 측정, 메트릭 및 종속성 및 작업 그래프 시각화"
  }, {
    "heading": "다음은-무엇인가요",
    "content": "데스크톱 콘솔 UI"
  }, {
    "heading": "다음은-무엇인가요",
    "content": "지능형 watch 모드"
  }, {
    "heading": "다음은-무엇인가요",
    "content": "TypeScript, React, Jest, Node.js, Docker, Kubernetes 등을 위한 공식 빌드 규칙"
  }, {
    "heading": "크레딧",
    "content": "Go 생태계를 안내해 준 Iheanyi Ekechukwu"
  }, {
    "heading": "크레딧",
    "content": "새로운 prune 명령을 반복 작업한 Miguel Oller와 Makeswift 팀"
  }],
  "headings": [{
    "id": "go로-다시-작성됨",
    "content": "Go로 다시 작성됨"
  }, {
    "id": "더-나은-해싱",
    "content": "더 나은 해싱"
  }, {
    "id": "실험적-정리된-워크스페이스",
    "content": "실험적: 정리된 워크스페이스"
  }, {
    "id": "파이프라인",
    "content": "파이프라인"
  }, {
    "id": "개선된-캐시-제어",
    "content": "개선된 캐시 제어"
  }, {
    "id": "다음은-무엇인가요",
    "content": "다음은 무엇인가요?"
  }, {
    "id": "크레딧",
    "content": "크레딧"
  }]
};
import __img0 from "./../../public/images/blog/turbo-0-4-0/turbo-vs-lerna-execution.png";
import {Authors} from '#components/authors';
export const toc = [{
  depth: 2,
  url: "#go로-다시-작성됨",
  title: _jsx(_Fragment, {
    children: "Go로 다시 작성됨"
  })
}, {
  depth: 2,
  url: "#더-나은-해싱",
  title: _jsx(_Fragment, {
    children: "더 나은 해싱"
  })
}, {
  depth: 2,
  url: "#실험적-정리된-워크스페이스",
  title: _jsx(_Fragment, {
    children: "실험적: 정리된 워크스페이스"
  })
}, {
  depth: 2,
  url: "#파이프라인",
  title: _jsx(_Fragment, {
    children: "파이프라인"
  })
}, {
  depth: 2,
  url: "#개선된-캐시-제어",
  title: _jsx(_Fragment, {
    children: "개선된 캐시 제어"
  })
}, {
  depth: 2,
  url: "#다음은-무엇인가요",
  title: _jsx(_Fragment, {
    children: "다음은 무엇인가요?"
  })
}, {
  depth: 2,
  url: "#크레딧",
  title: _jsx(_Fragment, {
    children: "크레딧"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 0.4.0"
    }), "\n", "\n", _jsx(Authors, {
      authors: ['jaredpalmer']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo v0.4.0 릴리스를 발표하게 되어 기쁩니다!"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "10배 빠름"
        }), ": ", _jsx(_components.code, {
          children: "turbo"
        }), "가 Go로 처음부터 다시 작성되어 훨씬 더 빠르게 되었습니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "더 스마트한 해싱"
        }), ": 개선된 해싱 알고리즘이 이제 전체 루트 잠금 파일의 내용 대신 해결된 종속성을 고려합니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "부분 잠금 파일 / 희소 설치"
        }), ": 주어진 대상에 필요한 패키지만 포함하는 정리된 루트 잠금 파일 및 모노레포 하위 집합을 생성합니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "세밀한 스케줄링"
        }), ": ", _jsx(_components.code, {
          children: "pipeline"
        }), " 구성을 통한 개선된 작업 오케스트레이션 및 옵션"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "더 나은 캐시 제어"
        }), ": 이제 작업별로 캐시 출력을 지정할 수 있습니다"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "go로-다시-작성됨",
      children: "Go로 다시 작성됨"
    }), "\n", _jsxs(_components.p, {
      children: ["처음에는 TypeScript로 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 프로토타입을 만들었지만, 로드맵의 특정 항목이 더 나은 성능을 요구한다는 것이 분명해졌습니다. 약 한 달간의 작업 끝에 드디어 Go 버전의 ", _jsx(_components.code, {
        children: "turbo"
      }), " CLI를 릴리스하게 되어 기쁩니다. 밀리초 단위로 부팅될 뿐만 아니라 새로운 Go 구현은 Node.js 구현보다 해싱에서 10배에서 100배 사이로 빠릅니다. 이 새로운 기반(그리고 곧 읽게 될 일부 기능)으로 Turborepo는 이제 Go의 놀라운 동시성 제어 덕분에 초은하계 크기의 프로젝트로 확장하면서도 놀랍도록 빠른 속도를 유지할 수 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "더-나은-해싱",
      children: "더 나은 해싱"
    }), "\n", _jsxs(_components.p, {
      children: ["v0.4.0에서는 해싱이 더 빠를 뿐만 아니라 ", _jsx(_components.em, {
        children: "훨씬"
      }), " 더 스마트합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["주요 변경 사항은 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 더 이상 해셔(주어진 작업이 캐시에 존재하는지 또는 실행해야 하는지 판단하는 알고리즘)에 루트 잠금 파일 내용의 해시를 포함하지 않는다는 것입니다. 대신 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 이제 루트 잠금 파일을 기반으로 패키지의 ", _jsx(_components.code, {
        children: "dependencies"
      }), " 및 ", _jsx(_components.code, {
        children: "devDependencies"
      }), "의 해결된 버전 집합을 해시합니다."]
    }), "\n", _jsx(_components.p, {
      children: "이전 동작은 루트 잠금 파일이 어떤 방식으로든 변경될 때마다 캐시를 폭발시켰습니다. 이 새로운 동작으로 잠금 파일을 변경하면 추가/변경/제거된 종속성의 영향을 받는 패키지에 대해서만 캐시가 무효화됩니다. 복잡하게 들리지만, npm에서 종속성을 설치/제거/업데이트할 때 변경 사항의 영향을 실제로 받는 패키지만 다시 빌드하면 된다는 의미입니다."
    }), "\n", _jsx(_components.h2, {
      id: "실험적-정리된-워크스페이스",
      children: "실험적: 정리된 워크스페이스"
    }), "\n", _jsx(_components.p, {
      children: "고객의 가장 큰 문제점/요청 중 하나는 대규모 Yarn Workspaces(또는 실제로 모든 워크스페이스 구현)로 작업할 때 Docker 빌드 시간을 개선하는 것이었습니다. 핵심 문제는 워크스페이스의 최고 기능--모노레포를 단일 잠금 파일로 줄이는 것--이 Docker 레이어 캐싱과 관련하여 최악이기도 하다는 것입니다."
    }), "\n", _jsxs(_components.p, {
      children: ["문제와 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 이제 이를 해결하는 방법을 설명하기 위해 예를 살펴보겠습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "frontend"
      }), ", ", _jsx(_components.code, {
        children: "admin"
      }), ", ", _jsx(_components.code, {
        children: "ui"
      }), ", ", _jsx(_components.code, {
        children: "backend"
      }), "라는 패키지 세트를 포함하는 Yarn 워크스페이스가 있는 모노레포가 있다고 가정해 봅시다. 또한 ", _jsx(_components.code, {
        children: "frontend"
      }), "와 ", _jsx(_components.code, {
        children: "admin"
      }), "이 동일한 내부 React 컴포넌트 라이브러리 패키지 ", _jsx(_components.code, {
        children: "ui"
      }), "에 모두 종속되는 Next.js 애플리케이션이라고 가정해 봅시다. 이제 ", _jsx(_components.code, {
        children: "backend"
      }), "에 모노레포의 다른 부분과 많은 코드를 공유하지 않는 Express TypeScript REST API가 포함되어 있다고 가정해 봅시다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "frontend"
      }), " Next.js 앱의 Dockerfile은 다음과 같습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Dockerfile",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " node:alpine "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " apk update"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "WORKDIR"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " /app"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Add lockfile and package.jsons"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " builder"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " *.json yarn.lock ./"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " packages/ui/*.json ./packages/ui/"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " packages/frontend/*.json ./packages/frontend/"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn install"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Copy source files"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " packages/ui/ ./packages/ui/"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " packages/frontend/ ./packages/frontend/"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Build"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn --cwd=packages/ui/ build"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn --cwd=packages/frontend/ build"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Start the Frontend Next.js application"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "EXPOSE"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " 3000"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'yarn'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ", "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'--cwd'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ", "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'packages/frontend'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ", "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'start'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이것이 작동하는 동안 훨씬 더 나을 수 있는 몇 가지가 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["대상 앱을 빌드하는 데 필요한 내부 패키지와 파일을 수동으로 ", _jsx(_components.code, {
          children: "COPY"
        }), "하고 어떤 것을 먼저 빌드해야 하는지 기억해야 합니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["Dockerfile에서 매우 일찍 루트 ", _jsx(_components.code, {
          children: "yarn.lock"
        }), " 잠금 파일을 올바른 위치로 ", _jsx(_components.code, {
          children: "COPY"
        }), "하지만, 이 잠금 파일은 ", _jsx(_components.em, {
          children: "전체"
        }), " 모노레포의 잠금 파일입니다."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "이 마지막 문제는 모노레포가 커질수록 특히 고통스러운데, 이 잠금 파일의 모든 변경이 앱이 실제로 새로운/변경된 종속성의 영향을 받는지 여부와 관계없이 거의 전체 재빌드를 트리거하기 때문입니다."
    }), "\n", _jsx(_components.p, {
      children: "....지금까지는."
    }), "\n", _jsxs(_components.p, {
      children: ["완전히 새로운 ", _jsx(_components.code, {
        children: "turbo prune"
      }), " 명령으로 이제 ", _jsx(_components.code, {
        children: "node_modules"
      }), "를 설치하지 않고도 대상 패키지에 대한 정리된 잠금 파일이 있는 희소/부분 모노레포를 결정적으로 생성하여 이 악몽을 해결할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Docker 내부에서 ", _jsx(_components.code, {
        children: "turbo prune"
      }), "을 사용하는 방법을 살펴보겠습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Dockerfile",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " node:alpine "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " apk update && apk add git"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "## Globally install `turbo`"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " npm i -g turbo"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Prune the workspace for the `frontend` app"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "as"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " pruner"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "WORKDIR"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " /app"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " . ."
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " turbo prune frontend --docker"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Add pruned lockfile and package.json's of the pruned subworkspace"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " installer"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "WORKDIR"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " /app"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=pruner /app/out/json/ ."
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=pruner /app/out/yarn.lock ./yarn.lock"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Install only the deps needed to build the target"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn install"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Copy source code of pruned subworkspace and build"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " builder"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "WORKDIR"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " /app"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=pruner /app/.git ./.git"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=pruner /app/out/full/ ."
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=installer /app/ ."
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " turbo run build frontend"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Start the app"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " builder "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "as"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " runner"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "EXPOSE"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " 3000"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'yarn'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ", "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'--cwd'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ", "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'packages/frontend'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ", "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "'start'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["그렇다면 ", _jsx(_components.code, {
        children: "turbo prune"
      }), "의 출력은 정확히 무엇일까요? 내부에 다음이 있는 ", _jsx(_components.code, {
        children: "out"
      }), "이라는 폴더입니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["정리된 워크스페이스의 package.json이 있는 ", _jsx(_components.code, {
          children: "json"
        }), " 폴더"]
      }), "\n", _jsxs(_components.li, {
        children: ["정리된 워크스페이스의 전체 소스 코드가 있지만 대상을 빌드하는 데 필요한 내부 패키지만 포함하는 ", _jsx(_components.code, {
          children: "full"
        }), " 폴더"]
      }), "\n", _jsxs(_components.li, {
        children: ["정리된 워크스페이스의 패키지에서 실제로 사용하는 종속성만 포함하는 원래 루트 잠금 파일의 정리된 하위 집합만 포함하는 ", _jsx(_components.em, {
          children: "새로운"
        }), " 정리된 잠금 파일."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["위의 덕분에 Docker는 이제 실제 이유가 있을 때만 각 애플리케이션을 다시 빌드하도록 설정할 수 있습니다. 따라서 ", _jsx(_components.code, {
        children: "frontend"
      }), "는 소스 또는 종속성(npm의 내부 또는 외부)이 실제로 변경된 경우에만 다시 빌드됩니다. ", _jsx(_components.code, {
        children: "admin"
      }), "과 ", _jsx(_components.code, {
        children: "backend"
      }), "도 마찬가지입니다. ", _jsx(_components.code, {
        children: "ui"
      }), "의 소스 코드 또는 종속성에 대한 변경은 ", _jsx(_components.code, {
        children: "frontend"
      }), "와 ", _jsx(_components.code, {
        children: "admin"
      }), " 모두의 재빌드를 트리거하지만 ", _jsx(_components.code, {
        children: "backend"
      }), "는 ", _jsx(_components.em, {
        children: "트리거하지 않습니다"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "이 예제가 사소해 보이지만 각 앱을 빌드하고 배포하는 데 최대 20분이 걸린다고 상상해 보세요. 특히 대규모 팀에서 이러한 절약은 빠르게 누적되기 시작합니다."
    }), "\n", _jsx(_components.h2, {
      id: "파이프라인",
      children: "파이프라인"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo를 더욱 세밀하게 제어할 수 있도록 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 구성에 ", _jsx(_components.code, {
        children: "pipeline"
      }), "을 추가했습니다. ", _jsx(_components.code, {
        children: "turbo"
      }), " 구성의 이 새 필드를 사용하면 모노레포의 npm 스크립트가 서로 어떻게 관련되어 있는지 및 일부 추가 작업별 옵션을 지정할 수 있습니다. 그런 다음 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 이 정보를 사용하여 모노레포의 작업을 최적으로 예약하고 그렇지 않으면 존재할 폭포를 축소합니다."]
    }), "\n", _jsx(_components.p, {
      children: "작동 방식은 다음과 같습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"turbo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // This `^` tells `turbo` that this pipeline target relies on a topological target being completed."
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // In english, this reads as: \"this package's `build` command depends on its dependencies' or"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // devDependencies' `build` command being completed\""
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        //  `dependsOn` without `^` can be used to express the relationships between tasks at the package level."
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // In English, this reads as: \"this package's `test` command depends on its `lint` and `build` command first being completed\""
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["위의 구성은 ", _jsx(_components.code, {
        children: "turbo"
      }), "에 의해 해석되어 실행을 최적으로 예약합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["실제로 무슨 의미일까요? 과거(Lerna 및 Nx와 같이)에는 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 토폴로지 순서로만 작업을 실행할 수 있었습니다. 파이프라인을 추가하면 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 이제 실제 종속성 그래프 외에도 토폴로지 \"작업\" 그래프를 구성하여 최대 동시성으로 작업을 실행해야 하는 순서를 결정하는 데 사용합니다. 최종 결과는 더 이상 작업이 완료되기를 기다리며 유휴 CPU 시간을 낭비하지 않는다는 것입니다(즉, 더 이상 폭포가 없습니다)."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "Turborepo scheduler",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsx(_components.h2, {
      id: "개선된-캐시-제어",
      children: "개선된 캐시 제어"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "pipeline"
      }), " 덕분에 이제 작업별로 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 캐시 동작을 열 수 있는 좋은 장소가 생겼습니다."]
    }), "\n", _jsx(_components.p, {
      children: "위의 예를 기반으로 이제 다음과 같이 전체 모노레포에서 캐시 출력 규칙을 설정할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"turbo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // Cache anything in dist or .next directories emitted by a `build` command"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // Cache the test coverage report"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"coverage/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // Never cache the `dev` command"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.em, {
        children: ["참고: 현재 ", _jsx(_components.code, {
          children: "pipeline"
        }), "은 프로젝트 수준에 존재하지만,\n이후 릴리스에서는 패키지별로 재정의할 수 있습니다."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "다음은-무엇인가요",
      children: "다음은 무엇인가요?"
    }), "\n", _jsx(_components.p, {
      children: "많은 내용이었지만 앞으로 더 많은 것이 있습니다. Turborepo 로드맵의 다음 내용은 다음과 같습니다."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "랜딩 페이지!"
      }), "\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "https://x.com/jaredpalmer/status/1359627800840462341",
          children: [_jsx(_components.code, {
            children: "@turborepo/server"
          }), "를 사용한 원격 캐싱"]
        })
      }), "\n", _jsx(_components.li, {
        children: "빌드 스캔, 원격 측정, 메트릭 및 종속성 및 작업 그래프 시각화"
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://x.com/jaredpalmer/status/1360315387372572672",
          children: "데스크톱 콘솔 UI"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["지능형 ", _jsx(_components.code, {
          children: "watch"
        }), " 모드"]
      }), "\n", _jsx(_components.li, {
        children: "TypeScript, React, Jest, Node.js, Docker, Kubernetes 등을 위한 공식 빌드 규칙"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "크레딧",
      children: "크레딧"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Go 생태계를 안내해 준 ", _jsx(_components.a, {
          href: "https://x.com/kwuchu",
          children: "Iheanyi Ekechukwu"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["새로운 ", _jsx(_components.code, {
          children: "prune"
        }), " 명령을 반복 작업한 ", _jsx(_components.a, {
          href: "https://x.com/ollermi",
          children: "Miguel Oller"
        }), "와 ", _jsx(_components.a, {
          href: "https://www.makeswift.com/",
          children: "Makeswift"
        }), " 팀"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
